import { find, filter, flatMap } from 'lodash';

export const checkUsedSerials = (seatsData) => {
  let errors = [];

  const cellsData = flatMap(
    seatsData.flat().filter((n) => n),
    (n) => n
  );

  seatsData.map((rowData, i) => {
    rowData &&
      rowData.map((cell, j) => {
        if (
          cell &&
          cell.serialNumber &&
          filter(cellsData, (n) => n.serialNumber == cell.serialNumber).length > 1
        ) {
          cell.error = ['seatingChart.assign.error.usedTwice'];
          errors = ['seatingChart.assign.error.usedTwice'];
        }
      });
  });

  return errors;
};

export const checkOutOfRange = (seatsData, ranges) => {
  let errors = [];

  seatsData.map((rowData, i) => {
    rowData &&
      rowData.map((cell, j) => {
        if (
          cell &&
          cell.serialNumber &&
          !find(
            ranges,
            (range) => range.rangeBegin <= cell.serialNumber && range.rangeEnd >= cell.serialNumber
          )
        ) {
          cell.error = ['seatingChart.assign.error.outOfRange'];
          errors = ['seatingChart.assign.error.outOfRange'];
        }
      });
  });

  return errors;
};

export const checkSerialNumberLength = (seatsData) => {
  let errors = [];

  seatsData.map((rowData, i) => {
    rowData &&
      rowData.map((cell, j) => {
        if (cell && cell.serialNumber && cell.serialNumber.length < 9) {
          cell.error = ['seatingChart.assign.error.nineDigits'];
          errors = ['seatingChart.assign.error.nineDigits'];
        }
      });
  });
  return errors;
};

export const checkSerialNumberStartDigit = (seatsData) => {
  let errors = [];

  seatsData.map((rowData, i) => {
    rowData &&
      rowData.map((cell, j) => {
        if (cell && cell.serialNumber && Number(cell.serialNumber[0]) < 1) {
          cell.error = ['seatingChart.assign.error.greaterThanZero'];
          errors = ['seatingChart.assign.error.greaterThanZero'];
        }
      });
  });
  return errors;
};
